import { render, staticRenderFns } from "./housemaid-quote-info.vue?vue&type=template&id=620f7bf8&scoped=true&"
import script from "./housemaid-quote-info.vue?vue&type=script&lang=js&"
export * from "./housemaid-quote-info.vue?vue&type=script&lang=js&"
import style0 from "./housemaid-quote-info.vue?vue&type=style&index=0&id=620f7bf8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620f7bf8",
  null
  
)

export default component.exports